export var EParentalFeature;
(function (EParentalFeature) {
    EParentalFeature[EParentalFeature["Invalid"] = 0] = "Invalid";
    EParentalFeature[EParentalFeature["Store"] = 1] = "Store";
    EParentalFeature[EParentalFeature["Community"] = 2] = "Community";
    EParentalFeature[EParentalFeature["Profile"] = 3] = "Profile";
    EParentalFeature[EParentalFeature["Friends"] = 4] = "Friends";
    EParentalFeature[EParentalFeature["News"] = 5] = "News";
    EParentalFeature[EParentalFeature["Trading"] = 6] = "Trading";
    EParentalFeature[EParentalFeature["Settings"] = 7] = "Settings";
    EParentalFeature[EParentalFeature["Console"] = 8] = "Console";
    EParentalFeature[EParentalFeature["Browser"] = 9] = "Browser";
    EParentalFeature[EParentalFeature["ParentalSetup"] = 10] = "ParentalSetup";
    EParentalFeature[EParentalFeature["Library"] = 11] = "Library";
    EParentalFeature[EParentalFeature["Test"] = 12] = "Test";
    EParentalFeature[EParentalFeature["SiteLicense"] = 13] = "SiteLicense";
    EParentalFeature[EParentalFeature["KioskMode"] = 14] = "KioskMode";
    EParentalFeature[EParentalFeature["Max"] = 15] = "Max";
})(EParentalFeature || (EParentalFeature = {}));
